module.exports = __webpack_public_path__ + "img/patient-info-refresh.42b8a766.svg";